import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import messages from './TopUpForm.messages';
import TopUpStatusMessage from '../RequestMoreFundsPanel/TopUpStatusMessages/TopUpStatusMessage';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    redirectToDashboard: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/'
            }
        })
});

export const DocsComplete = connect(
    null,
    mapDispatchToProps
)(({ redirectToDashboard }: ReturnType<typeof mapDispatchToProps>) => {
    useEffect(() => {
        tracking.ampli.applicationDocsComplete();
    }, []);

    return (
        <div className="m-auto text-center">
            <TopUpStatusMessage
                heading={<FormattedMessage {...messages.docsCompleteHeading} />}
                description={
                    <FormattedMessage {...messages.docsCompleteDescription} />
                }
            />
            <Button onClick={() => redirectToDashboard()}>
                <FormattedMessage {...messages.backToDashboard} />
            </Button>
        </div>
    );
});
